import Sammy1 from "../../assets/Sammy1.JPG";
import Sammy2 from "../../assets/Sammy2.JPG";
import samRock4 from "../../assets/samRock4.webp";
import sam7 from "../../assets/sam7.webp";

const careerData = [
  {
    id: 1,
    label: "FACET 01",
    title: "Actress",
    description:
      "As an actress, I put myself in a character’s shoes and tell their story through my body and my voice. I love being part of a cast, and my background in musical theater lends itself to my work as an actress today.",
    image: sam7,
    tabColor: "var(--peachy-orange)"
  },
  {
    id: 2,
    label: "FACET 02",
    title: "Singer-Songwriter",
    description:
      "I feel the most at home when I’m singing. It can be quite vulnerable to share original songs, but it is so fulfilling to hear that someone can relate to a personal experience of mine.",
    image: samRock4,
    tabColor: "var(--soft-pink)"
  },
  {
    id: 3,
    label: "FACET 03",
    title: "Vlogger",
    description:
      "As a Gen Z, I grew up watching my favorite YouTubers and feeling a genuine connection with them. I love documenting parts of my life and sharing it with the world. It’s just fun!",
    image: Sammy2,
    tabColor: "var(--blush-pink)"
  },
  {
    id: 4,
    label: "FACET 04",
    title: "Writer",
    description:
      "I recently began dabbling in children’s books and poetry. I have self-published 3 books so far. Feel free to check them out on Amazon!",
    image: Sammy1,
    tabColor: "var(--dusty-rose)"
  }
];

export default careerData;